import { green } from '@mui/material/colors';
import { ThemeOptions } from '@mui/material/styles';

export const DispatchThemeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    dark: {
      main: '#202632',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.dark.main,
          boxShadow: 'shadows.5',
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& label.Mui-focused': {
            color: '#00000099',
          },
          '& .MuiInput-underline:after': {
            borderBottomColor: '#303F9F',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: green[500],
          '&.Mui-checked': {
            color: green[500],
          },
        },
      },
    },
  },
  typography: {
    fontFamily: ['"PT Sans"', 'sans-serif'].join(','),
  },
};

export { Theme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    dark: Palette['primary'];
  }
  interface PaletteOptions {
    dark: PaletteOptions['primary'];
  }
}
